<template>
<VDBaseTemplate>
    <b-modal
      id="api-err-modal"
      v-model="apiErrModalShow"
      centered
      scrollable
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      title="Error"
      :header-bg-variant="'warning'"
      :header-text-variant="'light'">
      <span v-html="err_msg"></span>
      <b-button class="mt-3" block @click="hideModal">OK</b-button>
    </b-modal>
    <br><br><br>
    <div class="container-fluid main-container">
        <div class="col-md-12">
            <div class="header">
                <center>
                    <img
                        src="@/assets/images/logos/vecdyn_logo.svg"
                        class="mr-2"
                        width=45px
                    />
                    <h2>VecDyn Explorer</h2>
                </center>
            </div>
            <b-input-group class="mt-3">   
                <b-input-group-append>  
                    <b-button squared variant="success" class="mr-1" size="sm" @click="selectSpecies">
                        Explore by species & Location
                    </b-button>
                    <b-button squared variant="success" class="mr-1" size="sm" @click="selectProvider">
                        Explore by provider & title
                    </b-button>
                </b-input-group-append>
            </b-input-group>
            <br>
            <ExplorerInstructions />
            <b-row>
                <b-col cols="9" class="mr-1 mt-1">
                    <b-form-input
                        v-model="keywords"
                        placeholder="Search by phrase..."
                        @keypress.enter="searchByKeyword()"
                    ></b-form-input>
                </b-col>
                <b-col cols="3" class="mr-1 mt-1"></b-col>
            </b-row>
            <b-row v-for="index in queryFieldsetCount" :key="index">
                <b-input-group >
                    <b-col cols="3" class="mt-1">
                        <b-form-select 
                            v-if="speciesState"
                            v-model="fieldArray[index]"
                            :options="speciesOptionsList"
                        ></b-form-select>
                        <b-form-select
                            v-if="providerState"
                            v-model="fieldArray[index]"
                            :options="providerOptionsList"
                        ></b-form-select>
                    </b-col>
                    <b-col cols="3" class="mt-1">
                        <!-- <b-form-select v-model="operatorArray[index]" :options="operators" ></b-form-select> -->
                        <b-form-select v-model="operatorArray[index]">
                            <option
                                v-for="(operator, idx) in operators"
                                :key="idx"
                                :value="operator.value"
                                :title="operator.title || null"
                            >
                                {{ operator.text }}
                            </option>
                        </b-form-select>
                    </b-col>
                    <b-col cols="3" class="mt-1">
                        <b-form-input
                            v-model="termArray[index]"
                            placeholder="Enter a search term..."
                            @keypress.enter="searchByKeyword()"
                        ></b-form-input>
                    </b-col>
                    <b-col class="mt-1" v-if="userOnMobile">
                        <b-button
                            v-if="queryFieldsetCount > 1"
                            size="sm"
                            @click="removeQueryFieldset(index)"
                        >-</b-button>
                        <b-button
                            v-else
                            disabled
                            size="sm"
                        >-</b-button>
                        <b-button
                            v-if="index === queryFieldsetCount"
                            size="sm"
                            @click="incrementQueryFieldset"
                        >+</b-button>
                    </b-col>
                    <b-col class="mt-1" v-else>
                        <b-button
                            v-if="queryFieldsetCount > 1"
                            class="mr-1"
                            size="sm"
                            @click="removeQueryFieldset(index)"
                        >-</b-button>
                        <b-button
                            v-else
                            class="mr-1"
                            disabled
                            size="sm"
                        >-</b-button>
                        <b-button
                            v-if="index === queryFieldsetCount"
                            class="mr-1"
                            size="sm"
                            @click="incrementQueryFieldset"
                        >+</b-button>
                    </b-col>
                </b-input-group>
            </b-row>
            
            <!-- Mobile version -->
            <b-row v-if="userOnMobile">
                <b-col cols="12" class="mt-1">
                    <div style="float: right; display: inline;">
                        <!-- TODO IMPLEMENT THIS ONCE AN ENDPOINT EXISTS TO RETURN ALL ROW IDS (WITHOUT PAGINATION -->
                        <!-- <span v-if="queryActive">
                            <b-button class="ml-1" size="sm" @click="clearAllRows" v-if="allRowsSelected">
                                Clear All Rows
                            </b-button>
                            <b-button class="ml-1" size="sm" @click="selectAllRows" v-else>
                                Select All Rows
                            </b-button>
                        </span> -->
                        <b-button class="ml-1" style="width: 90px;" size="sm" @click="searchByKeyword">
                            Search
                        </b-button>
                        <b-button class="ml-1" style="width: 90px;" size="sm" @click="clear">
                            Clear
                        </b-button>
                        <b-button class="ml-1" style="width: 90px;" variant="primary" size="sm" @click="downloadCSV">
                            Download
                        </b-button>
                    </div>
                </b-col>
            </b-row>
            <b-row class="mt-4 mb-1" v-if="userOnMobile">
                <b-col cols="12" >
                    <div v-if="options.totalRows > -1" style="position: absolute; right: 0; bottom: -5px;">
                        {{ options.totalRows }} records returned
                    </div>
                </b-col>
            </b-row>
            <!-- Desktop version -->
            <b-row class="mb-2" v-else>
                <b-col cols="5">
                    <p class="mb-0">Click any row in the table to view its details page or click  
                        the checkbox beside any number of rows and then click the download button to download 
                        their data.</p>
                </b-col>
                <b-col cols="4" class="mt-1">
                    <div style="float: right; display: inline;">
                        <span v-if="queryActive">
                            <b-button class="ml-1" size="sm" @click="clearAllRows" v-if="allRowsSelected">
                                Clear All Rows
                            </b-button>
                            <b-button class="ml-1" size="sm" @click="selectAllRows" v-else>
                                Select All Rows
                            </b-button>
                        </span>
                        <b-button class="ml-1" style="width: 90px;" size="sm" @click="searchByKeyword">
                            Search
                        </b-button>
                        <b-button class="ml-1" style="width: 90px;" size="sm" @click="clear">
                            Clear
                        </b-button>
                        <b-button class="ml-1" style="width: 90px;" variant="primary" size="sm" @click="downloadCSV">
                            Download
                        </b-button>
                    </div>
                </b-col>
                <b-col cols="3">
                    <div style="position: relative; height: 100%; width: 100%;" v-if="!userOnMobile">
                        <div v-if="options.totalRows > -1" style="position: absolute; right: 0; bottom: -5px;">
                            {{ options.totalRows }} records returned
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-table
                ref="table"
                striped
                hover
                responsive
                selectable
                select-mode='single'
                bordered
                small
                head-variant="light"
                sticky-header="500px"

                @row-selected="onRowSelected"
                :items="myProvider"
                :fields="fields"
                :busy.sync="loading"
                :current-page="options.currentPage"
                :per-page="options.perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"

                tbody-tr-class="vt-table-rows"
            >
                <template v-if="speciesState" v-slot:cell(Select)="data">
                    <b-form-checkbox
                        v-model="selectedRows"
                        :value="data.item.Study_meta_data_id"
                    ></b-form-checkbox>
                </template>
                <template v-else v-slot:cell(Select)="data">
                    <b-form-checkbox
                        v-model="selectedRows"
                        :value="data.item.Publication_info_id"
                    ></b-form-checkbox>
                </template>
                <!-- A custom formatted header cell to allow for the displaying of tooltips -->
                <template v-slot:head()="field">
                    <span :title="field.field.title" style="font-size: small; white-space: nowrap;">
                        {{ field.label }}
                    </span>
                </template>
            </b-table>
            <b-pagination
                v-if="options.totalRows"
                v-model="options.currentPage"
                :total-rows="options.totalRows"
                :per-page="options.perPage"
                align="right"
                size="sm"
                class="my-0"
            ></b-pagination>
            <b-modal id="modal-1" size="md" scrollable title="Details">
                <b-table
                    responsive
                    stacked
                    :items="modal_items"
                    :fields="modal_fields"
                ></b-table>
            </b-modal>
        </div>
    </div>
</VDBaseTemplate>
</template>
<script>
import { HTTP } from "@/utilities/http-common";
import VDBaseTemplate from "@/layouts/VDBaseTemplate.vue";
import HandleErrors from "@/utilities/handle-errors";
import ExplorerInstructions from "@/components/instructions/ExplorerInstructions.vue";
export default {
    name: "vecdyn",
    mixins: [VDBaseTemplate],
    components: {
        VDBaseTemplate,
        ExplorerInstructions,
    },
    data() {
        return {
            options: {
                currentPage: 1,
                totalRows: 10,
                perPage: 10
            },
            loading: false,
            // search: "", // TODO: get rid of this?
            //--------------
            selectedRows: [],
            queryFieldsetCount: 1, // the number of sets of query fields
            speciesState: true,
            providerState: false, // is he using both of these?
            //---
            fieldArray: [],
            operatorArray: [],
            termArray: [],
            base: '', // TODO: get rid of this?
            keywords: '',
            returnAs: 'html',
            sortBy: "Study_meta_data_id",
            sortDesc: false,
            endpoint: "/api/vecdyntaxonlocation/",
            //--------------
            speciesOptionsList: [ // TODO: Make this dynamic
                { value: 'Taxon', text: 'Taxon' },
                { value: 'Genus_or_above', text: 'Genus Or Above' },
                { value: 'Taxonomic_rank', text: 'Taxonomic Rank' },
                { value: 'Location_description', text: 'Location Description'},
                { value: 'Country_name', text: 'Country Name' },
                { value: 'Administrative_division_1', text: 'Administrative Division 1' },
                { value: 'Administrative_division_2', text: 'Administrative Division 2' },
                { value: 'Title', text: 'Title' },
                { value: 'Collector', text: 'Collector' },
                // { value: null, text: 'None' }
            ],
            providerOptionsList: [
                { value: 'Title', text: 'Title' },
                { value: 'Collector', text: 'Collector' },
                { value: 'Description', text: 'Description' },
                { value: 'Dataset_type', text: 'Dataset Type' },
                // { value: null, text: 'None' }
            ],
            operators: [
                { value: 'eq', text: '=' },
                { value: 'neq', text: '!=' },
                { value: 'contains', text: 'contains' },
                { value: 'ncontains', text: '!contains' },
                { value: 'sw', text: 'Starts with'},
                { value: 'nsw', text: '!Starts with'},
                { value: 'lt', text: '<' },
                { value: 'lte', text: '<=' },
                { value: 'gt', text: '>'},
                { value: 'gte', text: '>=' },
                { value: 'in', text: 'in'},
                { value: 'nin', text: '!in'},
                // { value: null, text: 'None' }
            ],
            speciesLocationFields: [
                { key: 'Select', sortable: false, tdClass: 'text-truncate vt-table-cell ' },
                // { key: 'Study_meta_data_id', sortable: true },
                { key: 'Taxon', sortable: true, tdClass: 'text-truncate vt-table-cell ' },
                { key: 'Genus_or_above', sortable: true, tdClass: 'text-truncate vt-table-cell ' },
                { key: 'Taxonomic_rank', sortable: true, tdClass: 'text-truncate vt-table-cell ' },
                { key: 'Location_description', sortable: true, tdClass: 'text-truncate vt-table-cell ' },
                { key: 'Country_name', sortable: true, tdClass: 'text-truncate vt-table-cell ' },
                { key: 'Administrative_division_1', sortable: true, tdClass: 'text-truncate vt-table-cell ' },
                { key: 'Administrative_division_2', sortable: true, tdClass: 'text-truncate vt-table-cell ' },
                { key: 'Title', sortable: true, tdClass: 'text-truncate vt-table-cell ' },
                { key: 'Collector', sortable: true, tdClass: 'text-truncate vt-table-cell ' },
                
            ],
            providerTitleFields: [
                { key: 'Select', sortable: false },
                // { key: 'Publication_info_id', sortable: true },
                { key: 'Title', sortable: true },
                { key: 'Select', sortable: true },
                { key: 'Collector', sortable: true },
                { key: 'Description', sortable: true },
                { key: 'Dataset_type', sortable: true },
            ],
            fields: [],
            data: [],
            title: "VecDyn Explorer",
            totalItems: 0,
            stacked: false,
            selected: null,
            modal_items: [],
            modal_fields: [],
            rowIDString: "smdids=",
            err_msg: '',
            apiErrModalShow: false,
        };
    },
    computed: {
        // queryActive: function () {
        //     if (this.keywords && this.queryExecuted) {
        //         return true;
        //     } else if (this.fieldArray[1] && this.operatorArray[1] && this.termArray[1] && this.queryExecuted) {
        //         return true;
        //     } else {
        //         return false;
        //     }
        // },
    },
    watch: {
        view: function() {
            this.$refs.table.refresh();
        }
    },
    methods: {
        hideModal() {
            this.apiErrModalShow = false;
        },
        myProvider(ctx) {
            this.$bvModal.hide('modal-1');
            const that = this;

            // build the params object to be sent with the request.
            var params = new URLSearchParams();
            params.append("page", ctx.currentPage)
            params.append("keywords", that.keywords)
            params.append("sort_column", that.sortBy)
            params.append("sort_dir", that.sortDesc ? "desc" : "asc")
            params.append("return_as", that.returnAs)

            // load fieldArray, operatorArray, and termArray into the params obj
            var i;
            for (i=1; i < that.fieldArray.length; i++) {
                if (that.fieldArray[i].length != 0) {
                    params.append("field", that.fieldArray[i]);
                }
            }
            var j;
            for (j=1; j < that.operatorArray.length; j++) {
                if (that.operatorArray[j].length != 0) {
                    params.append("operator", that.operatorArray[j]);
                }
            }
            var k;
            for (k=1; k < that.termArray.length; k++) {
                if (that.termArray[k].length != 0) {
                    params.append("term", that.termArray[k]);
                }
            }

            var request = {
                params: params
            };

            return HTTP.get(this.endpoint, request)
            .then(response => {
                that.data = response.data.results;
                that.options.totalRows = parseInt(response.data.count);
                return that.data;
            })
            .catch(error => {
                this.err_msg = HandleErrors.HandleErrors(error);
                this.apiErrModalShow = true;
            });
        },
        onRowSelected(items) {
            let that = this;
            that.modal_items = items;
            this.$bvModal.show('modal-1');
        },
        beforeRouteLeave(to, from, next) {
            this.$bvModal.hide('modal-1');
            next();
        },
        //------------------------------
        //increment the search fields when the '+' is clicked
        incrementQueryFieldset() {
            this.queryFieldsetCount += 1;
        },
        decrementQueryFieldset() {
            this.queryFieldsetCount -= 1;
            this.fieldArray.pop();
            this.operatorArray.pop();
            this.termArray.pop();
        },
        removeQueryFieldset(index) {
            this.queryFieldsetCount -= 1;
            this.fieldArray.splice(index, 1);
            this.operatorArray.splice(index, 1);
            this.termArray.splice(index, 1);
        },
        // When the Search button is clicked, reset defaults and get results
        searchByKeyword(){
            // We always want to start on the first page of our results
            this.options.currentPage = 1;
            this.$refs.table.refresh();
        },
        // Resets all data to default settings.
        clear(){
            this.queryFieldsetCount = 1;
            this.fieldArray = [];
            this.operatorArray = [];
            this.termArray = [];
            this.keywords = '';
            this.sortDesc = false;
            this.selectedRows = [];
            this.$refs.table.refresh();
        },

        // Downloads .csv using URL built in buildCSVQuery().
        downloadCSV(){
            let csvEndpoint = "/api/vecdyncsv/?return_as=csv&";

            if(this.selectedRows.length){
                var i;
                for(i=0; i < this.selectedRows.length; i++){
                    csvEndpoint += (this.rowIDString + this.selectedRows[i]);
                    if (i != this.selectedRows.length - 1)
                        csvEndpoint += "&";
                }
            } else {
                alert('You have not selected any rows!');
            }

            HTTP.get(csvEndpoint)
            // HTTP.get(csvUrl, request)
                .then((response) => {
                    var fileURL = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    var fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    const now = new Date();
                    var fileName = "vec_dyn_download_" + now + ".csv";
                    fileLink.setAttribute("download", fileName);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    // console.log(response);
                })
                .catch((error) => {
                    this.err_msg = HandleErrors.HandleErrors(error);
                    this.apiErrModalShow = true;
                });
        },
        // Turns on species & location search, and turns off provider & title search. Default setting is on.
        selectSpecies(){
            if (!this.speciesState){
                this.fields = this.speciesLocationFields;
                this.rowIDString = "smdids=";
                this.providerState = false;
                this.speciesState = true;
                this.endpoint = "/api/vecdyntaxonlocation/";
                this.sortBy = "Study_meta_data_id",
                this.clear()
            }
            
        },
        // Turns on provider & title search, and turns off species & location search. Default setting is off.
        selectProvider(){
            if (!this.providerState) {
                this.fields = this.providerTitleFields;
                this.rowIDString = "piids=";
                this.speciesState = false;
                this.providerState = true;
                this.endpoint = "/api/vecdynauthortitle/";
                this.sortBy = "Publication_info_id",
                this.clear()
            }
        },
    },
    // Runs initial search using default settings.
    created(){
        document.title = "VecDyn Explorer";
        this.fields = this.speciesLocationFields;
    }
};
</script>
<style scoped>
    h1, h2, a, p {
        color: black !important;
        text-shadow: none;
    }

    p {
        font-size: smaller;
    }

    .table td, .table th {
        padding: 6px !important;
    }

    .header h2, h5 {
        display: inline;
        vertical-align:middle
    }
</style>